// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  bannerRequest: ['data'],
  bannerSuccess: ['data'],
  bannerFailure: ['err'],

  bannerCustomRequest: ['data'],
  bannerCustomSuccess: ['data'],
  bannerCustomFailure: ['err'],

  bannerCreateRequest: ['data'],
  bannerCreateSuccess: ['data'],
  bannerCreateFailure: ['err'],

  bannerDeleteRequest: ['data'],
  bannerDeleteSuccess: ['data'],
  bannerDeleteFailure: ['err'],

  bannerUpdateRequest: ['data'],
  bannerUpdateSuccess: ['data'],
  bannerUpdateFailure: ['err']

})

export const BannerTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: null,
  custom: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) => state.merge({ fetching: true, success: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

  export const successCustom = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    custom: data,
    err: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.BANNER_SUCCESS]: success,
  [Types.BANNER_REQUEST]: request,
  [Types.BANNER_FAILURE]: failure,

  [Types.BANNER_CUSTOM_SUCCESS]: successCustom,
  [Types.BANNER_CUSTOM_REQUEST]: request,
  [Types.BANNER_CUSTOM_FAILURE]: failure,

  [Types.BANNER_CREATE_SUCCESS]: manipulateSuccess,
  [Types.BANNER_CREATE_REQUEST]: manipulateRequest,
  [Types.BANNER_CREATE_FAILURE]: manipulateFailure,

  [Types.BANNER_DELETE_SUCCESS]: manipulateSuccess,
  [Types.BANNER_DELETE_REQUEST]: manipulateRequest,
  [Types.BANNER_DELETE_FAILURE]: manipulateFailure,

  [Types.BANNER_UPDATE_SUCCESS]: manipulateSuccess,
  [Types.BANNER_UPDATE_REQUEST]: manipulateRequest,
  [Types.BANNER_UPDATE_FAILURE]: manipulateFailure

})



// WEBPACK FOOTER //
// ./src/Redux/BannerRedux.js